import React, {Suspense}  from 'react';
import Axios              from 'axios'
import {
  BrowserRouter as Router,
  Switch, Route }         from "react-router-dom";
import { appendMetaTag,
        hostUrl,
        cmsHost,
        appendLinkTag }   from './assets';

import Body               from './components/Body'
//import Config             from './config/site.json'

import './App.scss';
import './assets/bootstrap.min.css';

//const Body      = React.lazy(() => import('./components/Body'))
const Adm       = React.lazy(() => import('./components/adm'))
const Home      = React.lazy(() => import('./components/Home'))
const Header    = React.lazy(() => import('./components/Header'))
const Footer    = React.lazy(() => import('./components/Footer'))
const Pedido    = React.lazy(() => import('./components/Pedido'))
const Details   = React.lazy(() => import('./components/Details'))
const Carrinho  = React.lazy(() => import('./components/Carrinho'))
const ResultadoBusca=React.lazy(() => import('./components/Busca'))
const MeusPedidos=React.lazy(() => import('./components/Pedido/MeusPedidos'))

const waiting = (<div
                    style={{width           :"100%",
                            height          :"100vh",
                            backgroundColor :"#F8F8F8",
                            alignItems      :"center",
                            justifyContent  :"center",
                            display         :"flex"}}
                  >
                    <div className="spinner-border"></div>
                  </div>)

Axios.defaults.withCredentials = true

export class App extends React.Component {
  state = {
    Config  : {},
    list    : [],
    site    : true
  }

  componentDidMount(){
    const site = window.location.pathname.toLowerCase().indexOf("/adm")!==0,
      url =  hostUrl,
      start = async () => {
        const resp  = await Axios.post(`${cmsHost}/config/site/token/`, {url})
        if(resp.data.res==="Ok"){
          const {data} = await Axios.post(`${cmsHost}/config/site/props/` + resp.data.site._id, {url}),
            Config = data.site;

          if(Config){
            const {metas, links, title, _id} = Config

            if(title) document.title = title

            if(metas) metas.forEach(m => appendMetaTag(m.name, m.content) ) 
            
            if(links) links.forEach( m => appendLinkTag(m.rel, `${cmsHost}/config/site/assets/${_id}/img/${m.href}`) )
          }

          this.setState({Config, site})
        }else this.setState({site})
      }
    start()
    //localStorage.setItem("list",JSON.stringify([]))
    if (!localStorage.getItem("list")){
      localStorage.setItem("list",JSON.stringify([]))
    }
  }

  componentDidMountSTATIC(){ 
    /*const site = window.location.pathname.toLowerCase().indexOf("/adm")!==0
    if(Config){
      const {metas, links} = Config
      this.setState({Config, site})
      document.title= Config.title
      if(metas){
        metas.every(m => {
          let meta    = document.createElement('meta')
          meta.name   = m.name
          meta.content= m.content
          document.querySelector('head').appendChild(meta)
          return true
        })
      }
      if(links){
        links.every(m => {
          let link    = document.createElement('link')
          link.rel    = m.rel
          link.href   = m.href
          document.querySelector('head').appendChild(link)
          return true
        })
      }
    }*/
  }
  
  addToList = item => {
    let {list} = this.state
    list.push(item)
    this.setState({list})
  }

  WaitingComponent(Component, data) {
    return props => (
      <Suspense fallback={waiting}>
        <Component {...props} data={data}/>
      </Suspense>
    );
  }

  render(){
    const {Config, list, site} = this.state 

    if(!Config.title && site)
      return waiting

    return (
      <Router>
        <h1 className="d-none">{Config.title}</h1>
        <Suspense fallback={<></>}>
          <Header
            data={Config && Config.header ? {...Config.header, social:Config.social, shop:Config.shop, token:Config._id, site} : null }/>
        </Suspense>

        <Body>
          <Switch>
            <Route exact path="/comprar/:produto/:id" component={this.WaitingComponent(Details, {Config, total: list.length})}/>
            <Route exact path="/comprar/:busca" component={this.WaitingComponent(ResultadoBusca, {Config, total: list.length, funcAddToList:this.addToList})}/>
            <Route exact path="/meus-pedidos" component={this.WaitingComponent(MeusPedidos, {Config})}/>
            <Route exact path="/pedido/finalizar" component={this.WaitingComponent(Pedido, {Config})}/>
            <Route exact path="/carrinho" component={this.WaitingComponent(Carrinho, {Config})}/>
            <Route exact path="/adm/:modulo" component={this.WaitingComponent(Adm, {Config})}/>
            <Route exact path="/adm/:modulo/:id" component={this.WaitingComponent(Adm, {Config})}/>
            <Route exact path="/adm" component={this.WaitingComponent(Adm, {Config})}/>
            <Route path="/" component={this.WaitingComponent(Home, {Config, total: list.length, funcAddToList:this.addToList})}/>
          </Switch>
        </Body>
        
        <Suspense fallback={<></>}>
          <Footer data={Config && Config.footer ? {...Config.footer, social:Config.social, shop: Config.shop, token:Config._id, site} : null }/>
        </Suspense>
      </Router>
      
    );
  }
}

export default App;
/*
            <Route exact path="/comprar/:marca/:modelo/:versao/:ano/:id" render={(props) => <Details {...props} data={{Config, stock}} />}/>
            <Route exact path="/" render={(props) => <Home {...props} data={{Config, stock}} />}/>

            <Route path="/comprar/:marca/:modelo/:versao/:ano/:id">
              <Suspense fallback={<div className="spinner-border"></div>}>
                <Details data={Config ? Config : null } {...props}/>
              </Suspense>
            </Route>
*/